import { FF_COMPARISON_EXPERIENCE } from '../constants'

// Defaults to true when window.flags isn't loaded yet or the flag is missing from LaunchDarkly.
// Only an explicit false disables compare.
export const isCompareFlagEnabled = () => {
  if (typeof window === 'undefined') return true
  const value = window?.flags?.[FF_COMPARISON_EXPERIENCE]
  return value === undefined || value === null ? true : !!value
}

export const isCompareEnabled = ({ isLoggedIn }) => {
  if (!isCompareFlagEnabled()) return false
  return (isLoggedIn)
    ? !!window?.Insight?.userPermissions?.includes('product_compare')
    : true
}
